<div class="order-items" *ngIf="dataSource.data">
  <header class="section-head">
    <div>
      <h3>Order items</h3>
      <p>Review and correct frames before receiving the vendor invoice.</p>
    </div>
    <button type="button" class="outline-btn" (click)="saveSectionChanges()">
      <mat-icon>save</mat-icon>
      <span>Save changes</span>
    </button>
  </header>

  <div class="ao-compact-table-wrap">
    <table class="ao-compact-table">
      <colgroup>
        <col class="ao-col-photo" />
        <col class="ao-col-frame" />
        <col class="ao-col-pricing" />
        <col class="ao-col-customer" />
        <col class="ao-col-info" />
        <col class="ao-col-actions" />
      </colgroup>
      <thead>
        <tr>
          <th class="ao-frame-heading" colspan="2">Frame details</th>
          <th class="ao-pricing-heading">Pricing</th>
          <th class="ao-for-heading">For</th>
          <th>Order info</th>
          <th class="ao-actions-heading">View · Log</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of dataSource.data; let i = index" [formGroup]="order">
          <td>
            <div class="ao-select-block">
              <input
                type="checkbox"
                [checked]="selection.isSelected(order)"
                (change)="toggleSelect(order)"
                (click)="$event.stopPropagation()"
                [attr.aria-label]="checkboxLabel(order, i)"
              />
              <div class="ao-frame-thumb">
                <app-images
                  type="product"
                  [images]="order.value.products[0].product.images"
                  (imagesChange)="updateImages($event, order.controls.products.controls[0].controls.product)"
                  [edit]="true"
                  [delete]="true"
                  [upload]="true"
                  [active]="false"
                  [productId]="order.value.products[0].product._id"
                ></app-images>
              </div>
            </div>
          </td>
          <td>
            <ng-container formGroupName="products">
              <ng-container [formGroupName]="0">
                <div class="ao-mini-fields ao-frame-fields">
                  <ng-container formGroupName="product">
                    <label>
                      <span>Model</span>
                      <input formControlName="model" aria-label="Frame model" />
                    </label>
                    <label>
                      <span>Color</span>
                      <input formControlName="color" aria-label="Frame color" />
                    </label>
                    <label>
                      <span>Size</span>
                      <input formControlName="size" aria-label="Frame size" />
                    </label>
                  </ng-container>
                  <label>
                    <span>Type</span>
                    <select formControlName="type" aria-label="Frame type">
                      <option *ngIf="!order.get('products.0.type')?.value" value=""></option>
                      <option *ngFor="let choice of typeChoices(order)" [value]="choice">{{ choice }}</option>
                    </select>
                  </label>
                  <ng-container formGroupName="product">
                    <label>
                      <span>Material</span>
                      <select formControlName="material" aria-label="Frame material">
                        <option value="">Select</option>
                        <option *ngFor="let choice of materialChoices(order)" [value]="choice">{{ choice }}</option>
                      </select>
                    </label>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
          <td>
            <ng-container formGroupName="products">
              <div class="ao-mini-fields ao-price-fields" [formGroupName]="0">
                <label class="ao-inline-money">
                  <span>Cost · {{ vendorCurrency }}</span>
                  <b>{{ currencySymbol(vendorCurrency) }}</b>
                  <input formControlName="cost" inputmode="decimal" aria-label="Frame cost" (keyup)="changeCost(order)" />
                </label>
                <label class="ao-inline-money">
                  <span>Retail · USD</span>
                  <b>$</b>
                  <input formControlName="retail" inputmode="decimal" aria-label="Frame retail price in US dollars" />
                </label>
              </div>
            </ng-container>
          </td>
          <td>
            <div class="ao-mini-fields ao-assignment-fields">
              <label>
                <span>Customer</span>
                <output class="ao-generated-value ao-customer-value" aria-label="Frame ordered for">
                  <a
                    *ngIf="!isStockOrder(order) && order.value.patient?._id"
                    class="ao-patient-name"
                    [routerLink]="['/admin/patient', order.value.patient._id]"
                  >{{ customerLabel(order) }}</a>
                  <ng-container *ngIf="isStockOrder(order) || !order.value.patient?._id">{{ customerLabel(order) }}</ng-container>
                </output>
              </label>
            </div>
          </td>
          <td>
            <div class="ao-mini-fields ao-tracking-fields">
              <label>
                <span>Invoice</span>
                <output class="ao-generated-value" aria-label="Invoice number">
                  <ng-container *ngIf="!isStockOrder(order)">{{ order.value.invoiceNumber | displayInvoice }}</ng-container>
                  <span class="fulfillment-ship-badge" *ngIf="order.value.fulfillment === 'SHIP' && order.value.status !== 'DISPENSED'">SHIP</span>
                </output>
              </label>
              <label>
                <span>ETA</span>
                <span class="eta-box">
                  <input
                    [matDatepicker]="picker"
                    formControlName="eta"
                    placeholder="mm/dd/yyyy"
                    aria-label="Estimated arrival date"
                  />
                  <button type="button" class="eta-toggle" (click)="picker.open()" aria-label="Open calendar">
                    <mat-icon>calendar_today</mat-icon>
                  </button>
                  <mat-datepicker #picker></mat-datepicker>
                </span>
              </label>
            </div>
          </td>
          <td>
            <div class="ao-row-actions" aria-label="Item actions">
              <button class="ao-site-icon" type="button" (click)="openOrderEdit($event, order)" aria-label="View item">
                <img src="assets/images/ao-icon-view.svg" alt="" />
              </button>
              <app-log-menu [order]="order" [small]="true"></app-log-menu>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-awaiting-frames-submit
  *ngIf="selection.hasValue()"
  [selected]="selection.selected"
  [(orderForm)]="orderForm"
  [orderIndex]="orderIndex"
  [currency]="vendorCurrency"
  [scanBusy]="invoiceScanBusy"
  (saveIncomingOrder)="saveIncomingOrder($event)"
  (updateTotal)="calculateTotal()"
  (invoiceFile)="scanVendorInvoice($event)"
></app-awaiting-frames-submit>
